import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { FeedItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Destination } from '../Destination';
import { Download } from '../Download';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Publish } from '../Publish';
import { Feed } from '../RowFor/Feed';
import { Size } from '../Size';

const FeedItem = (props: FeedItemProps) => {
    const {
        home,
        onCheckboxClick,
        isSelected,
        isFolder,
        thumbUrl,
        isVirus,
        ext,
        name,
        mtime,
        size,
        onDownload,
        id,
        storage,
        onPublish,
        isPublic,
    } = props;
    const windowWidth = useWindowWidth();
    const path = home === '/' ? 'Облако' : home;

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Feed {...props} checkboxClassname={newStyles.check} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic isFolder={isFolder} thumbUrl={thumbUrl} isVirus={!!isVirus} ext={ext || ''} />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} id={id} />
                            <Destination name={path} />
                            <Date date={mtime} />
                            <Size size={size} />
                            <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                            <Publish onClick={onPublish} isActive={isPublic} />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <ItemName name={name} ext={ext || ''} id={id} />
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                    <Destination name={path} noOverflow />
                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} />
                                    </span>
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    <Destination name={path} />
                                    {mtime && <Date date={mtime} />}
                                    <Size size={size} />
                                </>
                            )}
                            <div className={styles.actionsWrapper}>
                                <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                                <Publish onClick={onPublish} isActive={isPublic} />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default FeedItem;
